import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

import { IsoDatePipe } from "src/app/shared/pipes";

import { AllStrikesComponent } from './all-strikes/all-strikes.component';
import { HomeComponent } from './home/home.component';
import { AddHouseModalComponent } from './modals/add-house-modal/add-house-modal.component';
import { AddPicketlineModalComponent } from './modals/add-picketline-modal/add-picketline-modal.component';
import { AddShiftModalComponent } from './modals/add-shift-modal/add-shift-modal.component';
import { EditMemberComponent } from './modals/edit-member/edit-member.component';
import { EditWalkInfoComponent } from './modals/edit-walk-info/edit-walk-info.component';
import { NewStrikeComponent } from './new-strike/new-strike.component';
import { PicketSignInComponent } from './picket-sign-in/picket-sign-in.component';
import { PicketSignOutComponent } from './picket-sign-out/picket-sign-out.component';
import { StrikeDetailsComponent } from './strike-details/strike-details.component';
import { StrikeEditComponent } from './strike-edit/strike-edit.component';
import { StrikeMembersComponent } from './strike-members/strike-members.component';
import { StrikeRegisterComponent } from './strike-register/strike-register.component';
import { WalkHistoryComponent } from './walk-history/walk-history.component';
import { AppRoutingModule } from '../app-routing.module';
import { LayoutModule } from '../layout/layout.module';
import { ReportsModalComponent } from './modals/reports/reports.component';

@NgModule({
  declarations: [
    HomeComponent,
    StrikeDetailsComponent,
    WalkHistoryComponent,
    AddHouseModalComponent,
    AddShiftModalComponent,
    AddPicketlineModalComponent,
    EditMemberComponent,
    EditWalkInfoComponent,
    NewStrikeComponent,
    AllStrikesComponent,
    StrikeEditComponent,
    StrikeRegisterComponent,
    StrikeMembersComponent,
    PicketSignInComponent,
    PicketSignOutComponent,
    ReportsModalComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    ModalModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    LayoutModule,
  ],
  exports: [
    HomeComponent
  ],
  providers: [DatePipe, IsoDatePipe]
  
})
export class StrikesModule { }
